export enum SmtpEncryptionMethod {
    None = 'None',
    SSL = 'SSL / TLS / STARTTLS',
}
